import { FirstAndLastNameAndPhone, User } from "./commonTypes";
import { Company } from "./companyTypes";
import { SecurityOption } from "./productTypes";
import { DateTime } from "luxon";

export interface Job {
  id: number;
  reservationCode: string;
  createdBy?: User;
  phoneNumber: string;
  createdById: string;
  description: string;
  adminNotes?: string;
  startTime: DateTime;
  durationHours: number;
  location: string;
  status: JobStatus;
  jobAssignments?: JobAssignment[];
  createdAt: Date;
  updatedAt: Date;
  company?: Company;
  companyId?: number;
  securityOptionId: number;
  securityOption?: SecurityOption;
}

export interface JobAssignment {
  jobId: number;
  job?: Job;
  userId: string;
  user?: User;
}

export interface ActiveJob {
  id: number;
  reservationCode: string;
  createdBy: FirstAndLastNameAndPhone;
  phoneNumber: string;
  startTime: Date;
  securityOption: {
    id: number;
    title: string;
  };
}

export interface AdminJobSummary {
  activeJobs: ActiveJob[];
  newJobs: Job[];
}

export enum JobStatus {
  AWAITING_CONFIRMATION = "AWAITING_CONFIRMATION",
  AWAITING_USER_VERIFICATION = "AWAITING_USER_VERIFICATION",
  AWAITING_COMPLETION_CONFIRMATION = "AWAITING_COMPLETION_CONFIRMATION",
  AWAITING_PAYMENT = "AWAITING_PAYMENT",
  AWAITING_START = "AWAITING_START",
  READY_TO_START = "READY_TO_START",
  IN_PROGRESS = "IN_PROGRESS",
  CANCELED = "CANCELED",
  COMPLETED = "COMPLETED",
}
export interface CreateJobReq {
  description: string;
  startTime: Date;
  durationHours: number;
  location: string;
  securityOptionId: number;
  securityOptionPricingId: number;
}

export interface UpdateJobAssignmentReq {
  employeeIds: string[];
}

export interface UpdateJobReq {
  description?: string;
  startTime?: Date;
  durationHours?: number;
  location?: string;
  jobAssignments?: JobAssignment[];
  companyId?: number;
  status?: JobStatus;
  adminNotes?: string;
}
